<template>
    <div class="notes-view ">
        <active-palette></active-palette>

        <div class="gutter frame notes-content fade-in-up">
            <label>Notes</label>
            <textarea v-if="palette" name="Notes" id="notes" cols="30" rows="10" @change="updateNotes" :value="palette.notes"></textarea>
        </div>
    </div>
</template>

<script>
    import ActivePalette     from "./Components/Palette/ActivePalette";
    import UsesActivePalette from "./Components/Palette/UsesActivePalette";
    import Palettes          from "../Store/Palettes";
    import Transition        from "../../../Lib/Objects/Transition"

    export default {
        components: { ActivePalette },
        extends   : UsesActivePalette,

        data() {
            return {
            }
        },

        methods: {
            updateNotes({target: {value: notes}}) {
                new Palettes().updateNotes(notes, this.palette.id);
            }
        },

        mounted() {
            new Transition('.notes-content', 0.5).fadeIn();
            new Transition('.fade-in-up', 0.5).fadeInUp(32);
        },
    }

</script>
